import React from "react";
import styles from "./Layout.module.scss";
import HeaderComponent from "../HeaderComponent/HeaderComponent";
import FooterComponent from "../FooterComponent/FooterComponent";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import Navbar from "../UI/Navbar/Navbar";
import { selectIsAuthenticated } from "../../store/auth-slice";

type Props = {
  children?: React.ReactNode;
};

const Layout: React.FC<Props> = ({ children }, props) => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const isAdmin = useSelector((state: RootState) => state.auth.isAdmin);

  return (
    <div className={styles.Layout} {...props}>
      {isAuthenticated && <HeaderComponent />}
      {isAuthenticated && isAdmin && <Navbar />}
      {children}
      <FooterComponent />
    </div>
  );
};

export default Layout;
